import { Button } from "@mui/material";

export default function LoadMoreButton({ pageIndex, setPageIndex, label }) {
  return (
    <Button
      sx={{ mt: 2 }}
      fullWidth
      variant="outlined"
      color="secondary"
      onClick={() => setPageIndex(pageIndex + 1)}
    >
      Mehr {label} laden
    </Button>
  );
}
